import { Controller } from '@hotwired/stimulus'
import { GRID_EVENTS } from './grid_events'

// Bridges the "Reading your file…" overlay to parse completion. The upload's Turbo stream (inside the
// overlay) delivers it; a status check each time that stream (re)subscribes catches a broadcast it
// missed, and a slow poll covers a stream that never connects. All fire grid:parsed, which the grid
// handles idempotently.
export default class extends Controller {
  static values = {
    statusUrl: String,
    firstPollDelay: { type: Number, default: 3000 },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.finished = false
    this.pollTimer = setTimeout(this.poll, this.firstPollDelayValue)

    const stream = this.element.querySelector('turbo-cable-stream-source')
    if (!stream) return
    if (stream.hasAttribute('connected')) this.check()

    this.observer = new MutationObserver(() => {
      if (stream.hasAttribute('connected')) this.check()
    })
    this.observer.observe(stream, { attributes: true, attributeFilter: ['connected'] })
  }

  disconnect() {
    this.stop()
  }

  stop() {
    this.finished = true
    clearTimeout(this.pollTimer)
    this.observer?.disconnect()
  }

  poll = async () => {
    await this.check()
    if (!this.finished) this.pollTimer = setTimeout(this.poll, this.intervalValue)
  }

  check = async () => {
    try {
      const response = await fetch(this.statusUrlValue, { headers: { Accept: 'application/json' } })
      if (!response.ok || this.finished) return

      const { done, errored, upload_id: uploadId } = await response.json()
      if (!done || this.finished) return

      this.stop()
      window.dispatchEvent(new CustomEvent(GRID_EVENTS.parsed, { detail: { uploadId, errored } }))
    } catch {
      // The stream or the next poll still delivers the result.
    }
  }
}
